<template>
  <div>
    <div v-show="!isLoading" class="row" style="height:100%;">
      <div class="container-fluid">
        <div class="row" style="max-height: 40px;">
          <div class="col-xs-6">
            <router-link style="display: inline-flex; align-items: center; font-size: 20pt;" :to="{ name: 'ClassWeeks', query: { 'course': courseId }}" v-slot="{navigate}">
              <a class="btn btn-default" style="border: 0; text-decoration: initial; cursor: pointer;" @click="navigate">
                <i class="material-icons" style="font-size: 30pt;">arrow_back</i>
              </a>
            </router-link>
          </div>
          <div class="col-xs-6" style="text-align: right;">
            <AddActivityModal v-if="isTeacher" :preShowAddActDialog="showAddActDialog" :preVideoChoose="videoChoose"/>
          </div>
        </div>
      </div>
      <div v-if="isAdvanceMode" @mousedown="moveLeft()" @mouseup="stopMove()" id="left_btn" style="position: absolute; top: 50%; left: 0; padding: 10px; cursor: pointer;">&lt;</div>
      <div id="category_container" class="class_container" style="height: calc( 100% - 40px );">
        <CategoryCell v-show="showCategory(name)" v-for="(category , name) in categories" :key="name" :category="category" :style="categoryCellStyle"/>
      </div>
      <div v-if="isAdvanceMode" @mousedown="moveRight()" @mouseup="stopMove()" id="right_btn" style="position: absolute; top: 50%; right: 0; padding: 10px; cursor: pointer;">&gt;</div>
    </div>
    <Loading v-show="isLoading"></Loading>
  </div>
</template>
<style>

  @media(min-width: 992px){
    .class_container {
      display: flex;
      width: 100%;
      min-height: 200px;
      overflow-x: scroll;
    }
    .class_container::-webkit-scrollbar {
      display: none;
    }
  }
</style>
<script>
import Loading from '@/components/Utility/Loading.vue'
import CategoryCell from '@/components/Weeks/CategoryCell'
import AddActivityModal from '@/components/Weeks/AddActivityModal'
import $ from 'jquery'
export default {
  components: {
    Loading,
    CategoryCell,
    AddActivityModal
  },
  data () {
    return {
      isLoading: true,
      courseId: this.$parent.courseId,
      categories: {},
      isAdvanceMode: false,
      role: this.$parent.role,
      intervalId: null,
      showAddActDialog: this.$route.query.video !== undefined
    }
  },
  computed: {
    isTeacher: function () {
      return this.role === 'teacher'
    },
    isStudent: function () {
      return this.role === 'student'
    },
    id: function () {
      return parseInt(this.$route.query.week)
    },
    videoChoose: function () {
      return this.$route.query.video !== undefined ? parseInt(this.$route.query.video) : -1
    },
    categoryCellStyle: function () {
      return !this.isAdvanceMode ? 'min-width: 80%' : ''
    }
  },
  methods: {
    addActivity: function (activity) {
      this.categories[activity.category].activities.push(activity)
    },
    showCategory: function (name) {
      return this.isAdvanceMode || name === 'OTHERS'
    },
    moveLeft: function () {
      clearInterval(this.intervalId)
      this.intervalId = setInterval(function () {
        $('#category_container').scrollLeft($('#category_container').scrollLeft() - 10)
      }, 50)
    },
    moveRight: function () {
      clearInterval(this.intervalId)
      this.intervalId = setInterval(function () {
        $('#category_container').scrollLeft($('#category_container').scrollLeft() + 10)
      }, 50)
    },
    stopMove: function () {
      clearInterval(this.intervalId)
    }
  },
  mounted: async function () {
    await this.$store.dispatch('request', {
      route: `courses/${this.courseId}/weeks/${this.id}`
    }).then(result => {
      this.isAdvanceMode = result.mode === 'advance'
    })
    await this.$store.dispatch('request', {
      route: `courses/${this.courseId}/weeks/${this.id}/activities`
    }).then(result => {
      let categories = {}
      for (var catName in result) {
        let category = result[catName]
        let name = ''
        switch (catName) {
          case 'PRE-CLASS':
            name = '課前'
            break
          case 'IN-CLASS':
            name = '課上'
            break
          case 'AFTER-CLASS':
            name = '課後'
            break
          case 'OTHERS':
            name = '其他'
            break
          default:
            break
        }
        // if (this.isAdvanceMode) {
        category.name = name
        // }
        categories[catName] = category
      }
      this.categories = categories
    })
    this.isLoading = false
    $('#left_btn').css('left', $('#category_container').offset().left)
  }
}
</script>
